export default __webpack_public_path__ + "static/media/portfolio.c997a45a.gif";